import { Directive, Input, TemplateRef, ViewContainerRef, Injector } from '@angular/core';
import { AuthorizeService } from './authorize.service';

/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *userAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *userAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
@Directive({
    selector: '[isMainFO]'
})
export class IsMainFODirective {
    private authorities: any;
    constructor(
        private authorizeService: AuthorizeService,
        private injector: Injector,
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef) {
            // this.authorizeService = this.injector.get(AuthorizeService);
    }

    @Input()
    set isMainFO(isMain: boolean) {
        // this.authority = authority;
        this.updateView(isMain);
    }

    private updateView(isMain): void {
        let result = this.authorizeService.isMainFO();
        this.viewContainerRef.clear();
        if (isMain && result) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
        if (!isMain && !result) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }
}
